import React, { useEffect, useState, useRef } from "react";
import clsx from "clsx";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import styles from "./appLayout.module.css";
import { useRole } from "../../context/RoleContext";
import accessValidation from "../../utils/accessValidation";
import Header from "../../components/header/header";
import Sidebar from "../../components/sidebar/sidebar";

import { UsersProvider } from "../../context/UsersContext";
import { useInstitution } from "../../context/InstitutionContext";
import { useMantenedora } from "../../context/MantenedoraContext";
import { NotificationActionProvider, useNotificationAction } from "../../context/NotificationActionContext";
import ContractPendingBanner from "../../components/contractPendingBanner/contractPendingBanner";
// import { useGuidedTour } from "../../components/tour/useGuidedTour";

const AppLayoutInner = () => {
  // ACESSO GUIADO DESATIVADO
  // const steps = [
  //   {
  //     element: '.body',
  //     popover: {
  //       title: "Acesso Guiado",
  //       description: "Caso seja a primeira vez esteja logando é necessario você criar sua instituição. Para ter acesso as demais funcionalidades do sistema."
  //     },
  //   },
  //   {
  //     element: '.institution-form',
  //     popover: {
  //       title: "Primeiro Acesso",
  //       description: "Caso seja a primeira vez esteja logando é necessario você criar sua instituição. Para ter acesso as demais funcionalidades do sistema."
  //     },
  //   },
  //   {
  //     element: '.form-actions',
  //     popover: {
  //       title: "Salvar Instituição",
  //       description: "Crie sua instituição para ter acesso as demais funcionalidades do sistema."
  //     },
  //   },
  //   {
  //     element: '.sidebar',
  //     popover: {
  //       title: "Menu Lateral",
  //       description: "Após a criação da sua instituição você pode acessar o menu lateral para ter acesso as demais funcionalidades do sistema."
  //     },
  //   },
  //   {
  //     element: '.settings-sidebar',
  //     popover: {
  //       title: "Configurações",
  //       description: "Nessa seção você conseguirá alterar as informações da sua instituição, como nome, endereço e telefone.",
  //     },
  //   },
  //   {
  //     element: '.users-sidebar',
  //     popover: {
  //       title: "Usuários",
  //       description: "Nessa seção você conseguirá criar e editar usuários, além de gerenciar suas permissões.",
  //     },
  //   },
  //   {
  //     element: '.import-data-sidebar',
  //     popover: {
  //       title: "Importar Dados",
  //       description: "SELECIONE a aba de 'Importar dados' para ter acesso aos arquivos de importação."
  //     },
  //   },
  //   {
  //     element: '.mainContentSpace',
  //     popover: {
  //       title: "Arquivos Importados",
  //       description: "Nessa tabela você pode ver os arquivos importados."
  //     },
  //   },
  //   {
  //     element: '.import-data-button',
  //     popover: {
  //       title: "Importar arquivos",
  //       description: "Para importar arquivos, você deve primeiro selecionar qual o tipo de arquivo você deseja importar e em seguida importar o arquivo e em seguida importar seu arquivo.",
  //     },
  //   },
  //   {
  //     element: '.dashboard-sidebar',
  //     popover: {
  //       title: "Dashboard de Indicadores",
  //       description: "Após importar os arquivos, você conseguira ver os principais indicadores na sua tela de Dashboard",
  //     },
  //   },
  //   {
  //     element: '.finance-sidebar',
  //     popover: {
  //       title: "Indicadores Financeiros",
  //       description: "Caso você tenha importado arquivos de financeiro, você conseguira ver os seus indicadores financeiros na sua tela de Indicadores Financeiros",
  //     },
  //   },
  //   {
  //     element: '.education-sidebar',
  //     popover: {
  //       title: "Indicadores Acadêmicos",
  //       description: "Caso você tenha importado arquivos de acadêmico, você conseguira ver os seus indicadores acadêmicos na sua tela de Indicadores Acadêmicos",
  //     },
  //   },     
  //   {
  //     element: '.insights-sidebar',
  //     popover: {
  //       title: "Insights",
  //       description: "Com base nos dados importados, nós fazemos uma análise preditiva dos seus dados para te auxiliar em futuros decisões.",
  //     },
  //   },
  //   {
  //     element: '.finance-sidebar',
  //     popover: {
  //       title: "Financeiro",
  //       description: "Agora seleciona a aba de 'Financeiro' para ter acesso aos indicadores financeiros.",
  //     },
  //   },
  //   {
  //     element: '.finance-calendar',
  //     popover: {
  //       title: "Financeiro",
  //       description: "Aqui você conseguira filtrar os dados por período de tempo. O período padrão que os dados são carregados será sempre os últimos 12 meses a partir da data atual.",
  //     },
  //   },
  //   {
  //     element: '.finance-content',
  //     popover: {
  //       title: "Financeiro",
  //       description: "Aqui você tem acesso a todos os indicadores financeiros com base nos dados que você importou filtrados pelo período de tempo informado.",
  //     },
  //   }
  // ];

  const location = useLocation();
  const navigate = useNavigate();

  const { role } = useRole();
  const { institution, setInstitution } = useInstitution();
  const { mantenedora, getCurrentInstitution, hasMultipleInstitutions, selectedInstitutionId, institutionsLoading } = useMantenedora();

  const [isCollapsed, setIsCollapsed] = useState(false);
  const { triggerAction } = useNotificationAction();

  // Sincroniza o InstitutionContext com a instituição selecionada no MantenedoraContext.
  // Aguarda o carregamento das instituições para evitar sobrescrever com null.
  // Também cobre o caso de mantenedora com instituição única: sem múltiplas
  // instituições não há seleção, mas o InstitutionContext (zerado no logout)
  // precisa ser repopulado — getCurrentInstitution() já cai em institutions[0].
  useEffect(() => {
    if (institutionsLoading) return;
    if (selectedInstitutionId || !hasMultipleInstitutions) {
      const currentInst = getCurrentInstitution();
      if (currentInst && currentInst.id !== institution?.id) {
        setInstitution(currentInst);
      }
    }
  }, [selectedInstitutionId, hasMultipleInstitutions, institutionsLoading]);
  // ACESSO GUIADO DESATIVADO
  // const { firstAccess, setFirstAccess } = useInstitution();
  // const { startTour } = useGuidedTour(steps);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  // ACESSO GUIADO DESATIVADO
  // useEffect(() => {
  //   if (firstAccess) {
  //     startTour();
  //     setFirstAccess(false);
  //   }    
  // }, [firstAccess, startTour, setFirstAccess]);

  useEffect(() => {
    if (!role) return;

    const { isFreeFlow, route } = accessValidation({ 
      institution, 
      role, 
      hasMantenedora: !!mantenedora?.id 
    });

    if (!isFreeFlow) navigate(route);
  }, [location.pathname, role]);

  return (
    <div className={styles.container}>
      <Sidebar toggleCollapse={toggleCollapse} isCollapsed={isCollapsed} />

      <div
        className={clsx(styles.content, isCollapsed && styles.contentCollapsed)}
      >
        {/* ACESSO GUIADO DESATIVADO - onHelpClick={startTour} */}
        <Header isCollapsed={isCollapsed} onNotificationAction={triggerAction} />
        <ContractPendingBanner />

        <UsersProvider>
          <Outlet />
        </UsersProvider>
      </div>
    </div>
  );
};

const AppLayout = () => (
  <NotificationActionProvider>
    <AppLayoutInner />
  </NotificationActionProvider>
);

export default AppLayout;
